(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[78],{

/***/ 90149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ profileDropdownLinks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40956);
/* harmony import */ var remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75799);
/* harmony import */ var remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64409);
/* harmony import */ var remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63079);
/* harmony import */ var remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12923);
/* harmony import */ var remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44237);
/* harmony import */ var remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50834);
/* harmony import */ var remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14252);
/* harmony import */ var remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8__);









const profileDropdownLinks = [
    {
        label: "shops",
        href: "/shop",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "order.history",
        href: "/orders",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2___default()), {
            size: 24
        }),
        requiredAuth: true
    },
    {
        label: "refund.orders",
        href: "/orders/refunds",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8___default()), {
            size: 24
        }),
        requiredAuth: true
    },
    {
        label: "liked.shops",
        href: "/liked/shops",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "liked.products",
        href: "/liked/products",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "viewed.products",
        href: "/product/viewed",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "profile.settings",
        href: "/profile",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6___default()), {
            size: 24
        }),
        requiredAuth: true
    },
    {
        label: "site.settings",
        href: "/settings",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7___default()), {
            size: 24
        }),
        requiredAuth: false
    }
];


/***/ }),

/***/ 10299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74549);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5125);
/* harmony import */ var constants_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66750);
/* harmony import */ var contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8854);





function SEO(param) {
    let { title , description =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_DESCRIPTION */ .KM , image =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_IMAGE */ .T5 , keywords =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_KEYWORDS */ .cU  } = param;
    const { settings  } = (0,contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__/* .useSettings */ .r)();
    const projectTitle = (settings === null || settings === void 0 ? void 0 : settings.title) || constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_TITLE */ .k5;
    const currentURL = constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .WEBSITE_URL */ .o6;
    const siteTitle = title ? title + " | " + projectTitle : projectTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "Website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                property: "og:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                property: "og:author",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: (settings === null || settings === void 0 ? void 0 : settings.favicon) || "/favicon.png"
            })
        ]
    });
}


/***/ }),

/***/ 50887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LikedContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var _liked_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10047);
/* harmony import */ var _liked_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_liked_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34131);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);



const LikedProducts = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(2709), __webpack_require__.e(7876), __webpack_require__.e(3109)]).then(__webpack_require__.bind(__webpack_require__, 13109)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(13109)
            ]
    }
});
const LikedShops = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(2709), __webpack_require__.e(7876), __webpack_require__.e(7624)]).then(__webpack_require__.bind(__webpack_require__, 17624)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(17624)
            ]
    }
});
function LikedContainer(param) {
    let { type , data , isLoading =false , hasNextPage =false , isFetchingNextPage =false , fetchingNextPage  } = param;
    const renderView = ()=>{
        switch(type){
            case "shop":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LikedShops, {
                    // @ts-ignore
                    data: data,
                    isLoading: isLoading,
                    isFetchingNextPage: isFetchingNextPage,
                    hasNextPage: hasNextPage,
                    fetchingNextPage: fetchingNextPage
                });
            case "product":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LikedProducts, {
                    // @ts-ignore
                    data: data,
                    isLoading: isLoading,
                    isFetchingNextPage: isFetchingNextPage,
                    hasNextPage: hasNextPage,
                    fetchingNextPage: fetchingNextPage
                });
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {});
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_liked_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container),
        children: renderView()
    });
}


/***/ }),

/***/ 72059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SettingsContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var containers_sidebar_sidebar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(490);
/* harmony import */ var _settings_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19814);
/* harmony import */ var _settings_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_settings_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9120);





function SettingsContainer(param) {
    let { children  } = param;
    const isDesktop = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("(min-width:1024px)");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
        className: "container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_settings_module_scss__WEBPACK_IMPORTED_MODULE_4___default().container),
            children: [
                isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_settings_module_scss__WEBPACK_IMPORTED_MODULE_4___default().sidebar),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(containers_sidebar_sidebar__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                withLinks: true
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_settings_module_scss__WEBPACK_IMPORTED_MODULE_4___default().line)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_settings_module_scss__WEBPACK_IMPORTED_MODULE_4___default().body),
                    children: react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, (child)=>child ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(child) : null)
                })
            ]
        })
    });
}


/***/ }),

/***/ 490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Sidebar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var _sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(83807);
/* harmony import */ var _sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6339);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53218);
/* harmony import */ var remixicon_react_Store2FillIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64473);
/* harmony import */ var remixicon_react_Store2FillIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Store2FillIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_Heart3LineIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44900);
/* harmony import */ var remixicon_react_Heart3LineIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Heart3LineIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var remixicon_react_CustomerServiceLineIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54727);
/* harmony import */ var remixicon_react_CustomerServiceLineIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_CustomerServiceLineIcon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19457);
/* harmony import */ var remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var remixicon_react_LogoutCircleRLineIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55925);
/* harmony import */ var remixicon_react_LogoutCircleRLineIcon__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_LogoutCircleRLineIcon__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var utils_scrollToView__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(59778);
/* harmony import */ var contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77712);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21867);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var remixicon_react_LoginCircleLineIcon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99232);
/* harmony import */ var remixicon_react_LoginCircleLineIcon__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_LoginCircleLineIcon__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50959);
/* harmony import */ var components_profileDropdown_profileDropdownLinks__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(90149);















function Sidebar(param) {
    let { data , withLinks =false , onClose  } = param;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    const { query , pathname  } = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
    const { logout , isAuthenticated , openAuthModal  } = (0,contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_8__/* .useAuth */ .a)();
    const links = (0,react__WEBPACK_IMPORTED_MODULE_11__.useMemo)(()=>{
        if (isAuthenticated) {
            return components_profileDropdown_profileDropdownLinks__WEBPACK_IMPORTED_MODULE_12__/* .profileDropdownLinks.filter */ .a.filter((item)=>item.href !== "/shop");
        }
        return components_profileDropdown_profileDropdownLinks__WEBPACK_IMPORTED_MODULE_12__/* .profileDropdownLinks.filter */ .a.filter((item)=>!item.requiredAuth && item.href !== "/shop");
    }, [
        isAuthenticated
    ]);
    const handleLogout = ()=>{
        logout();
    };
    const handleClose = ()=>{
        if (onClose) {
            onClose();
        }
    };
    const renderAuthButton = ()=>{
        if (!isAuthenticated) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                type: "button",
                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().link),
                onClick: ()=>openAuthModal(),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().body),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_LoginCircleLineIcon__WEBPACK_IMPORTED_MODULE_10___default()), {
                                size: 24
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: t("login")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_6___default()), {
                        size: 20
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
            type: "button",
            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().link),
            onClick: handleLogout,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().body),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_LogoutCircleRLineIcon__WEBPACK_IMPORTED_MODULE_7___default()), {
                            size: 24
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: t("log.out")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_6___default()), {
                    size: 20
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("aside", {
        className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().links),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/shop",
                        className: "".concat((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().link), " ").concat(pathname === "/shop" && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().active)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().body),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Store2FillIcon__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    size: 24
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: t("shops")
                                })
                            ]
                        })
                    }),
                    !withLinks && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: {
                            pathname: "/liked/products",
                            query: {
                                shop_id: query === null || query === void 0 ? void 0 : query.id
                            }
                        },
                        className: "".concat((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().link), " ").concat(pathname.includes("/liked/products") && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().active)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().body),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Heart3LineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    size: 24
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: t("liked.products")
                                })
                            ]
                        })
                    }),
                    withLinks && links.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: item.href,
                            className: "".concat((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().link), " ").concat(pathname === item.href && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().active)),
                            onClick: handleClose,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().body),
                                children: [
                                    item.icon,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: t(item.label)
                                    })
                                ]
                            })
                        }, item.href))
                ]
            }),
            !!(data === null || data === void 0 ? void 0 : data.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().categoryContainer),
                children: data === null || data === void 0 ? void 0 : data.map((category)=>{
                    var ref;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: ()=>{
                            return (0,utils_scrollToView__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(category === null || category === void 0 ? void 0 : category.uuid, -70);
                        },
                        type: "button",
                        className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().category),
                        children: category === null || category === void 0 ? void 0 : (ref = category.translation) === null || ref === void 0 ? void 0 : ref.title
                    }, category === null || category === void 0 ? void 0 : category.id);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().links),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/help",
                        className: "".concat((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().link), " ").concat(pathname.includes("/help") && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().active)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().body),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_CustomerServiceLineIcon__WEBPACK_IMPORTED_MODULE_5___default()), {
                                        size: 24
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: t("help.center")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_6___default()), {
                                size: 20
                            })
                        ]
                    }),
                    renderAuthButton()
                ]
            })
        ]
    });
}


/***/ }),

/***/ 57812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useDebounce; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

function useDebounce(value, delay) {
    const [debounceValue, setDebounceValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setDebounceValue(value);
        }, delay);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        value,
        delay
    ]);
    return debounceValue;
}


/***/ }),

/***/ 59778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ scrollToView; }
/* harmony export */ });
function scrollToView(uuid) {
    let yOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (!uuid) {
        return;
    }
    const element = document.getElementById(uuid);
    if (element) {
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({
            top: y,
            behavior: "smooth"
        });
    } else {
        var ref, ref1;
        window.location.hash = uuid;
        const element1 = document.getElementById("the-end");
        const y1 = (element1 === null || element1 === void 0 ? void 0 : (ref = element1.getBoundingClientRect) === null || ref === void 0 ? void 0 : (ref1 = ref.call(element1)) === null || ref1 === void 0 ? void 0 : ref1.top) + window.pageYOffset + yOffset;
        window.scrollTo({
            top: y1,
            behavior: "smooth"
        });
    }
}


/***/ }),

/***/ 10047:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"liked_container__DDzAL","title":"liked_title__7_7g9"};

/***/ }),

/***/ 19814:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"settings_container__rObHi","sidebar":"settings_sidebar____hs3","line":"settings_line__zzjer","body":"settings_body__uMN7T"};

/***/ }),

/***/ 83807:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"sidebar_container__IjaDC","links":"sidebar_links__LM_pw","link":"sidebar_link__6YsEF","body":"sidebar_body__cwbZC","active":"sidebar_active__rrguH","categoryContainer":"sidebar_categoryContainer__3wSEp","category":"sidebar_category__b_8_c"};

/***/ }),

/***/ 19457:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(50959);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ArrowRightSLineIcon = function ArrowRightSLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z' })
  );
};

var ArrowRightSLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(ArrowRightSLineIcon) : ArrowRightSLineIcon;

module.exports = ArrowRightSLineIcon$1;


/***/ })

}]);